import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoTabImg from 'eco-design/sections/eco-tab-img';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

export default function Comp() {
    const { t } = useLang('theProduct.SectionF');
    const { locale = 'us' } = getLocal();

    const IS_JP_SITE = locale === 'jp';
    const itemsA = [
        {
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1748502870902/1.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744766997799/F1.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1748502870902/1.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744766997799/F1.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1748503193207/1-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744766997605/F1-h5.jpg',
            tabLabel: t('item1_title'),
            tabValue: '11',
        },
        {
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1748502871708/2.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744766998240/F2.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1748502871708/2.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744766998240/F2.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1748503194006/2-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744766998018/F2-h5.jpg',
            tabLabel: t('item2_title'),
            tabValue: '22',
        },
        {
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1748502871504/3.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744766998642/F3.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1748502871504/3.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744766998642/F3.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1748503193601/3-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744766998434/F3-h5.jpg',
            tabLabel: t('item3_title'),
            tabValue: '33',
        },
        {
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1748502871296/4.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744766999474/F5.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1748502871296/4.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744766999474/F5.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1748503193825/4-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744766999286/F5-h5.jpg',
            tabLabel: t('item4_title'),
            tabValue: '44',
        },
        {
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1748502871903/5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744766999059/F4.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1748502871903/5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744766999059/F4.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1748503194191/5-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744766998852/F4-h5.jpg',
            tabLabel: t('item5_title'),
            tabValue: '55',
        },
        ...(IS_JP_SITE
            ? [
                  {
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1748502871110/6.jpg',
                      pad: 'https://websiteoss.ecoflow.com/upload/image/1748502871110/6.jpg',
                      h5: 'https://websiteoss.ecoflow.com/upload/image/1748503193378/6-h5.jpg',
                      tabLabel: t('item6_title'),
                      tabValue: '66',
                  },
              ]
            : []),
    ];
    return (
        <div id="SectionF">
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            <EcoTabImg className={style.tabImg} items={itemsA} />
        </div>
    );
}
